/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import Checkbox from '@salesforce/design-system-react/components/checkbox';
import { getSvgIcon } from '../../../util/utilityFunctions';
import { getUserInfo } from '../../../store/ducks/userInfo';
import {
  SHOW_AGENCY_RECORDS,
  SHOW_STRYKER_RECORDS,
  AGENCY_VISIBILITY,
  AGENCY,
  SPORTS_MED,
} from '../../../util/constants';

interface Props {
  isAgencyRecord?: boolean;
  handleAgencyFilter?: (data: any, name: any) => void;
  isFilter?: boolean;
  selectedFilters?: any;
}

const AgencyTransaction: FC<Props> = ({
  isAgencyRecord,
  handleAgencyFilter,
  isFilter = false,
  selectedFilters,
}) => {
  const checkInitialStrykerRecord =
    selectedFilters?.showStrykerRecords === undefined ? true : selectedFilters?.showStrykerRecords;
  const checkInitialAgencyRecord =
    selectedFilters?.showAgencyRecords === undefined ? true : selectedFilters?.showAgencyRecords;
  const [filters, setFilters] = useState({
    showStrykerRecords: checkInitialStrykerRecord,
    showAgencyRecords: checkInitialAgencyRecord,
  });
  const userInfo = useSelector(getUserInfo);
  const checkBU = userInfo?.businessunit === SPORTS_MED;
  const agencyPersona = userInfo?.personas?.toLowerCase().includes(AGENCY);
  const checkVisibility =
    checkBU &&
    !agencyPersona &&
    AGENCY_VISIBILITY.some(visibility => !!userInfo?.personas?.includes(visibility));
  const iconPath = isAgencyRecord && checkBU ? getSvgIcon(AGENCY) : '';

  const handleSelect = (data: any, name: string) => {
    const selectedFilterValues = { ...filters, [name]: data };
    setFilters(selectedFilterValues);
    if (handleAgencyFilter) {
      handleAgencyFilter(data, name);
    }
  };

  return (
    <>
      {isFilter && checkVisibility && (
        <>
          <div className="show-hide-toggle" style={{ justifyContent: 'space-between', maxWidth: '250px' }}>
            <span className="toggle-text">Stryker</span>
            <div>
              <span>Hide/Show</span>
              <span>
                <Checkbox
                  labels={{
                    toggleEnabled: '',
                    toggleDisabled: '',
                  }}
                  variant="toggle"
                  checked={filters?.showStrykerRecords}
                  onChange={(event: any): void => {
                    handleSelect(event.target.checked, SHOW_STRYKER_RECORDS);
                  }}
                />
              </span>
            </div>
          </div>
          <div className="show-hide-toggle" style={{ justifyContent: 'space-between', maxWidth: '250px' }}>
            <span className="toggle-text">Agency</span>
            <div>
              <span>Hide/Show</span>
              <span>
                <Checkbox
                  labels={{
                    toggleEnabled: '',
                    toggleDisabled: '',
                  }}
                  variant="toggle"
                  checked={filters?.showAgencyRecords}
                  onChange={(event: any): void => {
                    handleSelect(event.target.checked, SHOW_AGENCY_RECORDS);
                  }}
                />
              </span>
            </div>
          </div>
        </>
      )}
      {!isFilter && checkBU && isAgencyRecord && (
        <img
          src={iconPath}
          className="logo-image"
          alt="company"
          style={{ width: '1rem', height: '1rem', marginRight: '4px' }}
        />
      )}
      {checkBU && !isAgencyRecord && <span style={{ marginLeft: '20px' }} />}
    </>
  );
};

export default AgencyTransaction;
